'use strict';

var init = require('./init');
var sniff = require('./lib/ySniff');
var extend = require('./util/extend');
var protocol = require('./util/protocol');
var _register = require('./register');
var bind = require('./bind');
var pkg = require('../package.json');
var isFunction = function isFunction(fn) {
    return typeof fn === 'function';
};
var COMMONSCHEME = 'scheme://';
var FUNNAMES = ['success', 'fail', 'complete'];

var _config = extend(true, {}, require('./config')),
    options = {
    apis: require('./apis'),
    events: require('./events')
},
    plugins = [],
    readyListenersCache = [];

var HySDK = global.hysdk = module.exports = {
    version: pkg && pkg.version || '1.1.0', /* 版本 */
    isReady: false, /* 是否已经 Ready */
    isInit: false, /* 是否已经初始化 */
    env: 'h5', /* 环境类型，可能为：hy, wechat, h5 */
    sniff: sniff, /* 环境嗅探 */
    bridge: null, /* 桥对象 */
    hy: {}, /* Hy Space */
    wechat: {}, /* Wechat Space */
    h5: {}, /* H5 Space */
    plugin: function plugin(_plugin) {
        return isFunction(_plugin) && plugins.push(_plugin);
    }, /* 添加 plugin */
    fns: _register.fns,
    /* 配置方法 */
    /**
     * 配置 HySDK <br />
     * hysdk 最重要的两个方法之一<br />
     * 对hysdk进行配置，包括是否开启调试，是否支持微信端和微信公众号的签名服务等<br />
     * 使用场景：在调用hysdk的一切接口前都要先调用一次config方法进行配置、初始化。
     * @method hysdk.config
     * @category Base
     * @example ./config.js[1-20]
     * @description
     *
     * | 参数 | 类型 | 描述 | 必选 | 注明 |
     * | :--: | :--: | :--: | :--: | :--: |
     * | debug | Bool | 是否支持调试模式 | X | 常用参数，默认false |
     * | bridgeReadyEvent | String | Hytive 桥 Ready 事件 | X | 不常用参数，默认 "WebViewJavascriptBridgeReady" |
     * | bridgeReadyTimeout | Number | 桥 Ready 最大延迟 | X | 不常用参数，默认 600 |
     * | apiTimeout | Number | API 超时时间 | X | 不常用参数，默认 1000 |
     * | hytiveReg | String | Hytive UA 判断正则 | X | 不常用参数，hysdk 默认 ""，qunar/fusion 插件默认 "(^&#124;\\s)(qunar[^\\/]+)\\/([\\d\\.]+)" |
     * | wechatSupport | Bool | 是否支持微信 | X | 常用参数，hysdk 默认 false；qunar/fusion 插件默认为 true |
     * | wechatScriptUrl | String | 微信 JSSDK 地址 | X | 不常用参数，默认 "//res.wx.qq.com/open/js/jweixin-1.0.0.js" |
     * | wechatSignatureUrl | String | 微信签名服务地址 | X | 不常用参数，hysdk 默认空，qunar/fusion 插件默认 "//ccweixin.qunar.com/chat/getJsConfig.do" |
     * | ucAPIScriptUrl | String | ucAPI 脚本地址 | X | 不常用参数，hysdk 不支持，qunar/fusion 插件默认 "//common.qunarzz.com/ucapi/prd/scripts/1.0.3/api@d20c312aba29a7178996dd57abcca695.js" |
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | √    |
     * | touch   |   √   |
     * | wechat  |   √   |
     * | ctrip   |   √   |
     *
     */
    config: function config(conf) {
        _config = extend(true, {}, _config, conf);
        if (!HySDK.isInit) {
            HySDK.isInit = true;
            // 执行插件逻辑
            plugins.forEach(function (plugin) {
                return plugin.call(HySDK, _config, options);
            });
            if (_config.hytiveReg) {
                HySDK.sniff.hy = new RegExp(_config.hytiveReg).test(navigator.userAgent.toLowerCase());
            }
            // 进行初始化逻辑
            init.call(HySDK, _config, readyListenersCache);
        }
    },
    /* Ready 监听&回调 */
    /**
     * HySDK 初始化完成回调<br />
     * hysdk 最重要的两个方法之一<br />
     * Hy或微信的桥注入之后的回调<br />
     * @method hysdk.ready
     * @category Base
     * @example ./ready.js[1-10]
     * @description
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | √    |
     * | touch   |   √   |
     * | wechat  |   √   |
     * | ctrip   |   √   |
     *
     */
    ready: function ready(listener) {
        if (isFunction(listener)) {
            if (HySDK.isReady) {
                listener(HySDK.env);
            } else {
                readyListenersCache.push(listener);
            }
        }
    },
    /* 拓展接口 */
    /**
     * 通过register扩展接口<br />
     * 使用场景：业务线有新的非公共HY插件，方便根据自身业务需求，向HySDK已有的hy或其指定的命名空间下挂载Hy bridge<br />
     * 注意：注册事件时，需要传第四个参数 isEvent
     * @method hysdk.register
     * @category Base
     * @example ./register.js[1-30]
     * @description
     *
     * | 参数 | 类型 | 描述 | 必选 | 注明 |
     * | :--: | :--: | :--: | :--: | :--: |
     * | name | String | 接口名称 | √ | 常用参数 |
     * | key | String | 对应native接口 | √ | 常用参数 |
     * | namespace | String | 命名空间，业务方建议使用自己的命名空间 | x | 常用参数，默认 "hy" |
     * | isEvent | Bool | 拓展的接口是否是事件 | x | 常用参数，默认false |
     *
     * 本接口不依赖hysdk.ready，一定记得先注册再使用，否则会报undefined。
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | √    |
     * | Hy Browser (非qunar) | √    |
     * | touch   |   X   |
     * | wechat  |   X   |
     * | ctrip   |   X   |
     *
     */
    register: function register(name, key) {
        var namespace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'hy';
        var isEvent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        if (!name || !key) {
            console.error('参数name、key必传');
            return;
        }
        if (name.indexOf('once') === 0) {
            name = name.substring(4).replace(/\w/, function ($1) {
                return $1.toLowerCase();
            });
            isEvent = true;
        } else if (name.indexOf('on') === 0) {
            name = name.substring(2).replace(/\w/, function ($1) {
                return $1.toLowerCase();
            });
            isEvent = true;
        }
        var conf = { namespace: namespace, bridge: key };
        conf[namespace] = true;
        HySDK[namespace] = HySDK[namespace] || {};
        if (isEvent) {
            bind.initNameSpaceFns(HySDK, name, conf);
            bind.initEventFns(HySDK, name, namespace);
            return;
        }
        _register.setUpFunction(HySDK, name, conf, _config.debug, _config.apiTimeout);
        HySDK[namespace][name] = _register.bind(HySDK, name, namespace);
    },
    /**
     * 通过registerScheme扩展接口<br />
     * 使用场景：将客户端有相应的 scheme 封装成 JS API<br />
     * @method hysdk.registerScheme
     * @category Base
     * @example ./registerScheme.js
     * @description
     *
     * | 参数 | 类型 | 描述 | 必选 | 注明 |
     * | :--: | :--: | :--: | :--: | :--: |
     * | name | String | 接口名称 | √ | 常用参数 |
     * | scheme | String | 对应Scheme接口 | √ | 常用参数 |
     *
     * 本接口不依赖hysdk.ready，一定记得先注册再使用，否则会报undefined。
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | X    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X   |
     * | wechat  |   X   |
     * | ctrip   |   X   |
     *
     */
    registerScheme: function registerScheme(name, scheme) {
        if (sniff.scheme) {
            var _protocol = sniff.scheme + '://';
            if (scheme.indexOf(COMMONSCHEME) === 0) {
                scheme = scheme.replace(COMMONSCHEME, _protocol);
            }
            if (scheme.indexOf('//') === 0) {
                scheme = scheme.replace('//', _protocol);
            }
        }
        HySDK[name] = function (param) {
            param = param || {};
            var params = [];
            Object.keys(param).forEach(function (v) {
                if (FUNNAMES.indexOf(v) === -1) {
                    params.push(v + '=' + param[v]);
                }
            });
            param.scheme = scheme + '?' + params.join('&');
            return HySDK.schemeForResult(param);
        };
    },
    /* 工具 */
    util: {
        extend: extend,
        protocol: protocol,
        script: require('./util/load').script,
        register: _register
    }
};

if (typeof window !== 'undefined') {
    window.hysdk = HySDK;
}


//////////////////
// WEBPACK FOOTER
// ../src/index.js
// module id = 2
// module chunks = 0 2 4